module.exports = "/assets/data/4c28dc4a0a9ed4ddd28d2f98ef93520d-DE56.data.json";